import React from 'react'
import CartWidget from './CartWidget'
import { Link } from 'react-router-dom'
const NavbarContainer = () => {
  return (
    <div>
        <nav class="navbar">
        <ul class="navbar-menu">
            <li class="navbar-item">
              <CartWidget />
            </li>
            <li class="navbar-item">
              <Link to='/'><button type="button" class="btn btn-outline-info">Menu</button></Link>
            </li>
            <li class="navbar-item">
              <Link to='/cuentas'><button type="button" class="btn btn-outline-success">Cuentas</button></Link>
            </li>
            
        </ul>
        </nav>
  </div>
  )
}

export default NavbarContainer